export default "__VITE_ASSET__C73yvk4p__"